import { RegionsEnum, RegionsEnumRuntype } from '@luminovo/api-contracts/regions';

import type { MarketSavingsDetailOffer } from './schemas';
import type { MarketSavingsStandardPriceSnapshot } from './standardPriceSnapshot';

/** Presentation adapter only. Live display schemas never participate in decoding the durable snapshot. */
export function standardPriceSnapshotOffers(
    snapshot: MarketSavingsStandardPriceSnapshot,
    priceType: 'standard_price' | 'contract_price' = 'standard_price',
): MarketSavingsDetailOffer[] {
    return snapshot.offers.map((offer) => ({
        id: offer.id,
        partId: offer.partId,
        priceType,
        provenance: { source: 'tenant-offer-api', scope: 'tenant', ...(offer.label ? { label: offer.label } : {}) },
        date: offer.observedAt === null ? undefined : new Date(offer.observedAt).toISOString().slice(0, 10),
        supplier: offer.supplier
            ? {
                  ...offer.supplier,
                  stockLocation: RegionsEnumRuntype.exclude([RegionsEnum.Unknown])
                      .optional()
                      .catch(undefined)
                      .parse(offer.supplier.stockLocation),
              }
            : undefined,
        stock: offer.stock,
        leadTimeDays: offer.leadTimeDays,
        priceBreaks: offer.priceBreaks.map((priceBreak) => ({ ...priceBreak })),
    }));
}
